import {graphql, StaticQuery} from 'gatsby';
import * as React from 'react';

import RecipeCarouselV2Section from '../../components/recipeCarouselV2/RecipeCarouselV2Section';
import {useSelectedProduct} from '../../components/recipeCarouselV2/SelectedProductContext';
import {Edges} from '../../customGraphQlModels/Edges';
import {GroupedPreferenceModel} from '../../customGraphQlModels/GroupedPreferenceModel';
import {findBySkuOrItemumber} from '../../customGraphQlModels/ProductDbModel';
import {ContentfulBaseProps} from '../ContentfulBaseProps';
import {RecipeInfoQueryModel} from '../productCard/AllProductsQueryModel';
import RecipeCarouselV2ContentModel from './RecipeCarouselV2ContentModel';
import {resolveRecipeCarouselV2Sku} from './utils/getRecipeCarouselV2Week';

type QueryModel = RecipeInfoQueryModel & {allGroupedPreferences: Edges<GroupedPreferenceModel>};

const ContentfulRecipeCarouselV2: React.FunctionComponent<ContentfulBaseProps> = ({baseModel}) => {
  const model = baseModel as RecipeCarouselV2ContentModel;
  const {selectedItemNumber, selectedPreferenceCode} = useSelectedProduct();
  const sku = resolveRecipeCarouselV2Sku(selectedItemNumber, model);

  if (!sku) {
    return null;
  }

  return (
    <StaticQuery
      query={graphql`
        query {
          allProductDb {
            edges {
              node {
                ...ProductDbFragment
              }
            }
          }
          allGroupedPreferences {
            edges {
              node {
                ...GroupedPreferencesFragment
              }
            }
          }
        }
      `}
      render={(data: QueryModel) => (
        <RecipeCarouselV2Section
          model={model}
          sku={sku}
          product={findBySkuOrItemumber(data.allProductDb, sku)}
          preferences={data.allGroupedPreferences.edges.map(e => e.node)}
          preferenceCode={selectedPreferenceCode}
        />
      )}
    />
  );
};

export default ContentfulRecipeCarouselV2;
